import { useState, useEffect, useMemo } from 'react';
import { initialFilterState, initialUIState } from '../pages/dashboard/profiles/state/initialState';
import { createHandlers } from '../pages/dashboard/profiles/state/handlers';

export const useProfileFiltersUI = () => {
  // UI State
  const [filterState, setFilterState] = useState(initialFilterState);
  const [uiState, setUIState] = useState(initialUIState);
  const [activeMetric, setActiveMetric] = useState('total');

  // Create handlers
  const handlers = useMemo(() => 
    createHandlers(setFilterState, setUIState), 
    [setFilterState, setUIState]
  );

  // Get filter labels for UI display
  const getFilterLabel = (type) => {
    const filters = filterState[type];
    if (!filters?.length) {
      return type === 'status' ? 'Status' : 
             type.charAt(0).toUpperCase() + type.slice(1) + 's';
    }
    if (filters.length === 1) {
      return type === 'org' ? filters[0].name : filters[0];
    }
    const typeName = type === 'org' ? 'Organizations' : 
                     type === 'status' ? 'Status' : 
                     type.charAt(0).toUpperCase() + type.slice(1) + 's';
    return `${filters.length} ${typeName}`;
  };

  // Handle metric clicks
  const handleMetricClick = (metricType, onFilterChange) => {
    if (activeMetric === metricType) {
      // If clicking the same metric, clear the filter
      setActiveMetric('total');
      onFilterChange({ type: 'status', value: null });
      onFilterChange({ type: 'created_at', value: null });
    } else {
      setActiveMetric(metricType);
      switch (metricType) {
        case 'newThisWeek':
          const oneWeekAgo = new Date();
          oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
          onFilterChange({ type: 'created_at', value: oneWeekAgo.toISOString() });
          onFilterChange({ type: 'status', value: null });
          break;
        case 'submitted':
        case 'accepted':
        case 'active':
        case 'waitlist':
          onFilterChange({ type: 'status', value: [metricType] });
          onFilterChange({ type: 'created_at', value: null });
          break;
        case 'total':
          // Clear all filters
          onFilterChange({ type: 'status', value: null });
          onFilterChange({ type: 'created_at', value: null });
          break;
      }
    }
  };

  // Reset active metric when filters are cleared
  useEffect(() => {
    const hasNoFilters = !filterState.status.length && !uiState.searchQuery;
    if (hasNoFilters) {
      setActiveMetric('total');
    }
  }, [filterState.status, uiState.searchQuery]);

  return {
    // State
    filterState,
    uiState,
    activeMetric,

    // Handlers
    ...handlers,
    handleMetricClick,

    // Helpers
    getFilterLabel
  };
}; 